import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Tianjia = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M2 24q0-4.475 1.73-8.564 1.67-3.948 4.714-6.992Q11.488 5.4 15.436 3.73 19.526 2 24 2q4.475 0 8.564 1.73 3.948 1.67 6.992 4.714 3.044 3.044 4.714 6.992Q46 19.526 46 24q0 4.475-1.73 8.564-1.67 3.948-4.714 6.992-3.044 3.044-6.992 4.714Q28.474 46 24 46q-4.475 0-8.564-1.73-3.948-1.67-6.992-4.714Q5.4 36.512 3.73 32.564 2 28.474 2 24Zm4 0q0 3.663 1.414 7.006 1.366 3.23 3.858 5.722 2.492 2.492 5.722 3.858Q20.337 42 24 42q3.663 0 7.006-1.414 3.23-1.366 5.722-3.858 2.492-2.492 3.858-5.722Q42 27.663 42 24q0-3.663-1.414-7.006-1.366-3.23-3.858-5.722-2.492-2.492-5.722-3.858Q27.663 6 24 6q-3.663 0-7.006 1.414-3.23 1.366-5.722 3.858-2.492 2.492-3.858 5.722Q6 20.337 6 24Zm16-8v6h-6a2 2 0 1 0 0 4h6v6a2 2 0 1 0 4 0v-6h6a2 2 0 1 0 0-4h-6v-6a2 2 0 1 0-4 0Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
